<template>
  <v-container id="org-machine" style="background-color: white" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12">
        <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
          <v-tab v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <div
        class="border-gray text-black btn-add-department"
        style="width: fit-content; padding: 6px 10px; float: right"
        v-if="totalItem == 0 && checkAuthorization('setting-organization_create')"
        color="white"
        @click="clickAddDepartment">
      Thêm bộ phận<v-icon>mdi-plus</v-icon>
    </div>

    <div>
      <template v-for="(item, index) in listDepartment">
        <v-card-title class="title-department">
          <div
              class="title-department-content"
              @dblclick="editDepartment(item, index)">
            <span v-if="!item.editable">{{ item.name }}</span>
            <input
                :id="'edit_name_' + item.id"
                :value="item.name"
                placeholder="Nhập tên bộ phận..."
                style="padding: 5px; border: 2px solid #C4C4C4"
                maxlength="255"
                @blur="updateDepartment(index, item, $event)"
                @change="updateDepartment(index, item, $event)"
                @keyup.enter="item.editable = !item.editable"
                v-if="item.editable">
            <span
                v-if="checkAuthorization('setting-organization_delete')"
                @click="deleteDepartment(item)"
                class="btn-action-department">Xóa</span>
          </div>

          <div
              class="border-gray text-black btn-add-department"
              v-if="index == 0 && checkAuthorization('setting-organization_create')"
              color="white"
              @click="clickAddDepartment">
            Thêm bộ phận<v-icon>mdi-plus</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="border-table" style="border-radius: 5px;">
            <div style="background-color: #F3F2F9; font-weight: 500" class="d-flex">
              <div class="col-4 border-table">
                Vị trí
              </div>
              <v-col class="col-3 border-table">
                Bộ chỉ số
              </v-col>
              <v-col class="col-3 border-table">
                Nhân sự
              </v-col>
              <v-col class="col-2 border-table">
                Chức năng
              </v-col>
            </div>



            <div v-if="!_.isEmpty(item.org)">
              <template>
                <div class="d-flex">
                  <div
                      style="position: relative;"
                      class="col-4 d-flex content-tree-note">
                    <div class="tree-header-name">

                      <div
                          @click="getDetailBranch(index, item)"
                          v-if="!item.org.showEdit">
                        {{ item.org.name }}
                      </div>
                      <input
                          v-else
                          style="height: 35px; padding: 5px; width: 100%; border: 2px solid #C4C4C4; background: white"
                          maxlength="255"
                          placeholder="Nhập tên..."
                          :id="'input_branch_name_' + item.org.id"
                          class="tree-header-name"
                          v-model="item.org.name"
                          @blur="updateBranch(item.org)"
                          @change="item.org.showEdit = !item.org.showEdit"/>
                      <div class="btn-action-branch">
                        <span
                            v-if="checkAuthorization('setting-organization_update')"
                            @click="editBranch(item.org)">Sửa</span>
<!--                         | -->
<!--                        <span @click="deleteBranch(item)">Xóa</span>-->
                      </div>
                    </div>
                    <div v-if="item.org.children && item.org.children.length">
                      <v-icon
                          @click="item.org.isShow = !item.org.isShow;"
                          class="icon-header-tree-note"
                          v-if="item.org.isShow">mdi-chevron-down</v-icon>
                      <v-icon
                          @click="item.org.isShow = !item.org.isShow;"
                          class="icon-header-tree-note"
                          v-else>mdi-chevron-right</v-icon>
                    </div>
                  </div>

                  <div class="col-3 border-table">

    <!--                <v-col>-->
                      <template>

                        <span
                            class="item-kpi-content mr-1"
                            v-for="kpi in item.org.indicators">
                          {{ kpi.name }}
                        </span>
                        <div v-if="checkAuthorization('setting-organization_update')">
                          <v-menu
                              bottom
                              offset-y
                              absolute
                              v-model="item.org.openMenu"
                              content-class="wrapper-v-menu"
                              :close-on-content-click="false"
                          >
                            <template v-slot:activator="{ on }">
                              <div v-show="item.org.indicators && item.org.indicators.length">
                                <v-icon size="14">mdi-pencil</v-icon>
                                <span
                                    @click="openFormSelectKpi(item.org)"
                                    class="btn-edit-kpi mt-3"
                                    dark v-on="on"
                                    height="30px" >
                                  Chỉnh sửa
                                </span>
                              </div>
                              <div
                                  v-show="!item.org.indicators || !item.org.indicators.length"
                                  :class="item.org.openMenu ? 'btn-add-item selected' : 'btn-add-item'"
                              >
                                <v-icon
                                    v-on="on"
                                    style="transform: translate(-1.5px, -1px)"
                                    @click="openFormSelectKpi(item.org)"
                                    :color="item.org.openMenu ? 'white' : 'black'">
                                  mdi-plus</v-icon>
                              </div>
                            </template>

                          <!-- Form select kpi-->
                            <template>
                              <v-list
                                  class=""
                                  width="285px"
                                  style="max-height: 400px;"
                                  outlined
                              >
                                <v-list-item
                                    style="min-height: unset"
                                    three-line>
                                  <v-list-item-content class="overflow-visible pb-0">
                                    <v-row style="width: 100%; padding: 0px 20px">
                                      <v-text-field
                                          v-model="filterForm.kpiName"
                                          outlined
                                          hide-details
                                          placeholder="Tìm kiếm ..."
                                          dense
                                          clearable
                                          @input="searchKpi()"
                                      />
                                    </v-row>
                                  </v-list-item-content>
                                </v-list-item>

                                <template v-if="item.kpiList && item.kpiList.length">
                                  <div class="item-kpi-wrapper my-2 mt-4">
                                    <span
                                        class="item-kpi-content mr-2 mt-2"
                                        v-for="kpi in item.kpiList">
                                      {{ kpi }}
                                      <v-icon color="#7367F0">mdi-check</v-icon>
                                    </span>
                                  </div>
                                </template>

                                <div style="max-height: 268px; overflow-y: auto;" class="style-1">
                                  <div
                                      v-for="ite in kpiListAllCopy"
                                      class="item-kpi-wrapper my-2">
                                    <h3 class="py-2 border-bottom"
                                        style="word-break: break-word">
                                      {{ ite.name }}
                                    </h3>

                                    <div>
                                      <span
                                          v-for="kpiItem in ite.indicators"
                                          :class="kpiItem.selected ? 'item-kpi-content mr-2 mt-2' : 'item-kpi-content-unselect mr-2 mt-2'"
                                          @click="handleSelectKpi(kpiItem)">
                                      {{ kpiItem.name }}
                                        <v-icon v-if="listKpiSelected.includes(kpiItem.id)"
                                                color="#7367F0">mdi-check</v-icon>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="text-center py-4 item-kpi-wrapper">
                                  <div
                                      @click="saveKpiForBranch(item.org)"
                                      class="mx-0 btn-confirm py-2">Xác nhận</div>
                                </div>
                              </v-list>
                            </template>


                          </v-menu>
                        </div>
                      </template>

                  </div>


                  <div class="col-3 border-table">


                    <div v-for="rank in item.org.ranks">
                      <div
                          class="rank-data-content"
                          v-show="!rank.showEdit">
                        {{ rank.name }}
                        <span class="rank-item-actions">
                          <span
                              v-if="checkAuthorization('setting-organization_update')"
                              style="cursor: pointer"
                              @click="editRank(rank)">Sửa</span>
                          <span
                              v-if="checkAuthorization('setting-organization_update')
                                && checkAuthorization('setting-organization_delete')"
                          > | </span>
                          <span
                              v-if="checkAuthorization('setting-organization_delete')"
                              style="cursor: pointer"
                              @click="deleteRank(item.org, rank)">Xóa</span>
                        </span>
                      </div>
                      <input
                          v-show="rank.showEdit"
                          style="height: 35px; padding: 5px; width: 100%; border: 2px solid #C4C4C4"
                          :id="'input_rank_name_' + rank.id"
                          placeholder="Nhập tên lộ trình..."
                          class="rank-header-name"
                          v-model="rank.name"
                          maxlength="255"
                          @blur="updateRank(rank)"
                          @keyup.enter="rank.showEdit = !rank.showEdit"/>

                      <div class="content-user-in-rank my-2 d-flex align-center">
                        <span v-for="(user, indexU) in rank.users">
                          <span v-if="indexU < 3">
                            <img
                                v-if="user.avatar"
                                class="item-avatar-user mr-1"
                                :src="user.avatar"/>
                            <img v-else
                               class="item-avatar-user mr-1"
                               src="../../assets/default-avatar.jpg"/>
                          </span>
                        </span>
                        <span
                            class="more-item-user d-flex align-center mr-1 justify-center"
                            v-if="rank.users.length > 3">
                            +{{rank.users.length - 3}}
                        </span>
                        <!--Form add user for rank-->
                        <v-menu
                            bottom
                            offset-y
                            absolute
                            v-model="rank.openMenu"
                            content-class="wrapper-v-menu"
                            :close-on-content-click="false">

                          <template v-slot:activator="{ on }">
                            <span
                                v-if="checkAuthorization('setting-organization_create')
                                  || checkAuthorization('setting-organization_delete')"
                                :class="rank.openMenu ? 'btn-add-item selected' : 'btn-add-item'">
                              <v-icon
                                  @click="openFormSelectUser(rank)"
                                  v-on="on"
                                  style="transform: translate(-1.5px, -1px)"
                                  :color="rank.openMenu ? 'white' : 'black'">
                                mdi-plus</v-icon>
                            </span>
                          </template>

    <!--                      <template>-->
                            <v-list
                                class=""
                                width="285px"
                                style="max-height: 415px;"
                                outlined
                            >
                              <v-list-item
                                  style="min-height: unset"
                                  three-line>
                                <v-list-item-content class="overflow-visible pb-0">
                                  <v-row style="width: 100%; padding: 0px 20px">
                                    <v-text-field
                                        v-model="filterForm.name"
                                        outlined
                                        hide-details
                                        placeholder="Tìm kiếm ..."
                                        dense
                                        @input="searchUser()"
                                    />
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>

                              <div v-if="rank.users && rank.users.length"
                                   class="item-user-list-wrapper my-2">
                                <h3>Nhân viên thuộc rank</h3>
                                <div
                                    class="item-user-content mr-2 d-flex justify-space-between align-center"
                                    v-for="user in rank.users">
                                  <div v-if="user.firstName && user.firstName"
                                       class="pt-1">{{ user.lastName + ' ' + user.firstName }}</div>
                                  <div v-else
                                       class="pt-1">{{ user.fullName }}</div>
                                  <input
                                      v-if="checkAuthorization('setting-organization_delete')"
                                      style="width: 18px; height: 18px"
                                      type="checkbox"
                                      class="mt-0"
                                      v-model="listUserSelected"
                                      :value="user.id"
                                  />

                                </div>
                              </div>

                              <h3 class="item-user-list-wrapper mt-4">Nhân viên</h3>
                              <div
                                  v-if="checkAuthorization('setting-organization_create')"
                                  class="item-user-list-wrapper my-2 style-1 wrapper-list-item">
                                <div
                                    class="item-user-content mr-2 style-1 d-flex justify-space-between align-center"
                                    v-for="user in userListCopy">
                                  <div class="pt-1">{{ user.fullName }}</div>
                                  <input
                                      style="width: 18px; height: 18px"
                                      type="checkbox"
                                      class="mt-0"
                                      v-model="listUserSelected"
                                      :value="user.id"
                                      :label="user.name"
                                  />

                                </div>
                              </div>

                              <div class="text-center py-4 item-user-list-wrapper">
                                <div
                                    v-if="checkAuthorization('setting-organization_create')
                                      || checkAuthorization('setting-organization_update')
                                      || checkAuthorization('setting-organization_delete')"
                                    @click="saveUserForRank(rank)"
                                    class="mx-0 btn-confirm py-2">Xác nhận</div>
                              </div>
                            </v-list>
    <!--                      </template>-->

                        </v-menu>

                      </div>
                    </div>


                  </div>

                  <div class="col-2 tree-action-btn border-table">
                  <div class="d-flex action row" style="font-size: 12px">
                    <div
                        v-if="checkAuthorization('setting-organization_create')"
                        class="btn-action-item"
                        color="primary"
                        @click="addBranch(item)">
                      <div><v-icon style="transform: rotate(90deg);">mdi-source-branch</v-icon></div>
                      <span>Thêm mới cấp dưới</span>
                    </div>

                    <div class="btn-action-item"
                         v-if="checkAuthorization('setting-organization_create')"
                         color="primary"
                         @click="addRank(item.org)">
                      <div><v-icon>mdi-lightning-bolt-outline</v-icon></div>
                      <span>Thêm <br/> lộ trình làm việc</span>
                    </div>

                    <div class="btn-action-item">
                      <v-menu
                          bottom
                          offset-y
                          absolute
                          v-model="item.org.openMenuPermission"
                          content-class="wrapper-v-menu style-1"
                          :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <div
                              v-if="checkAuthorization('setting-organization_create')"
                              @click="openMenuSelectPermission(item.org)"
                              v-on="on"
                              style="height: 100%;">
                            <div>
                              <v-icon>mdi-view-grid-plus-outline</v-icon>
                            </div>
                            <span>Nhóm quyền</span>
                          </div>

                        </template>

                        <!--Form select permission-->
                        <template>
                          <v-list
                              class=""
                              width="285px"
                              style="max-height: 400px;"
                              outlined>
                            <div style="max-height: 320px; overflow-y: auto;" class="style-1">
                              <div
                                  v-for="groupPermission in groupPermissionList"
                                  class="item-kpi-wrapper my-2">
                                <h3 class="py-2 border-bottom" style="word-break: break-word">
                                  {{ groupPermission.name }}
                                </h3>
                                <div>
                                <div
                                    v-for="permission in groupPermission.roles"
                                    :class="listPermissionSelected.includes(permission.id) ? 'item-role-content mr-2 mt-2' : 'item-role-content-unselect mr-2 mt-2'"
                                    @click="handleSelectRoles(permission)">
                                  {{ permission.name }}
                                  <v-icon
                                      v-if="listPermissionSelected.includes(permission.id)"
                                      color="#7367F0">mdi-check</v-icon>
                                </div>
                                </div>
                              </div>
                            </div>

                            <div class="text-center py-4 item-kpi-wrapper">
                              <div
                                  @click="saveRolesForBranch(item.org)"
                                  class="mx-0 btn-confirm py-2">Xác nhận</div>
                            </div>
                          </v-list>
                        </template>
                      </v-menu>
                    </div>
                  </div>
                </div>
                </div>

                <tree-branch
                    v-show="item.org.isShow"
                    :userList="userList"
                    :noteData="item.org.children"
                    :kpiListAll="kpiListAll"
                    :newTempOrgName="tempOrgName"
                    :groupPermissionList="groupPermissionList"
                    :keyName="index"/>
              </template>
            </div>
          </div>

        </v-card-text>
      </template>
    </div>

    <div
        v-if="!loading && totalItem === 0"
        class="no-result text-center mt-2"
    >
      <span>Chưa có bộ phận nào</span>
    </div>

    <v-row>
      <v-col cols="12" sm="6" />
      <v-col cols="12" sm="6">
<!--        <v-pagination-->
<!--            v-if="totalItem > limit"-->
<!--            v-model="currentPage"-->
<!--            :length="getTotalItem(totalItem)"-->
<!--            class="justify-sm-end"-->
<!--            prev-icon="mdi-menu-left"-->
<!--            next-icon="mdi-menu-right"-->
<!--        />-->
      </v-col>
    </v-row>

    <!-- component-->
    <modal-create-department></modal-create-department>
  </v-container>
</template>

<script>
import ModalCreateDepartment from './components/ModalCreateDepartment';
import TreeBranch from './components/TreeBranch';
import RepositoryFactory from '../../repositories/RepositoryFactory';
import { OrganizationMachineTabMenu } from "./organizationContant.js";
import moment from "moment";
const organizationMachineRepository = RepositoryFactory.get('organization_machine');
const UserRepository = RepositoryFactory.get('user')
const RoleRepository = RepositoryFactory.get('role')

export default {
  components: {
    ModalCreateDepartment,
    TreeBranch
  },
  data() {
    return {
      listDepartment: [],
      loading: false,
      totalItem: 0,
      limit: 10,
      currentPage: 0,
      tabs: [],
      showFormCreateDepartment: false,
      userList: [],
      filterForm: {
        name: '',
        kpiName: ''
      },
      listUserSelected: [],
      userListCopy: [],
      kpiListAll: [],
      kpiListAllCopy: [],
      listKpiSelected: [],
      groupPermissionList: [],
      listPermissionSelected: [],
      tempRankName: '',
      tempOrgName: ''
    };
  },
  async created() {
    await this.getUserList();
    Bus.$on('get-list-user-ministry-available', () => {
      this.getUserList();
    })
    Bus.$on('update-data-list-department', () => {
      this.getListDepartment()
    });
    this.tabs = OrganizationMachineTabMenu();
    this.getListDepartment();
    this.getKpiList();
    this.getTopicList();
  },
  beforeDestroy() {
    Bus.$off('get-list-user-ministry-available');
    Bus.$off('update-data-list-department');
  },
  computed: {

  },
  methods: {
    async getListDepartment() {
      this.loading = true
      const loading = this.$loading.show()
      const response = await organizationMachineRepository.list();
      this.loading = false;
      loading.hide()
      if (response.success) {
        let listDepartmentTemp = _.get(response, 'data', []).map(item => {
          if(!item.org.children) {
            item.org.children = []
          }
          item.org.isShow = false;
          item.org.showEdit = false;
          return {
            ...item,
            editable: false
          }
        })
        this.listDepartment = listDepartmentTemp;
        this.totalItem = _.get(response, 'data', []).length
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    async clickAddDepartment() {
      this.selectedCombo = {}
      this.showFormCreateDepartment = true
      Bus.$emit('department-show-form')
    },
    async editDepartment(item, index) {
      if(this.checkAuthorization('setting-organization_update')) {
        this.listDepartment[index].editable = true;
        setTimeout(function(){
          document.getElementById('edit_name_' + item.id).focus();
          document.getElementById('edit_name_' + item.id).click();
        }, 300);
      }
    },
    async updateDepartment(index, item, e) {
      const value = e.target.value;

      if(!value.trim()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Tên bộ phận không được để trống!'
        });
        this.$nextTick( () => {
          document.getElementById(`input_branch_name_${item.id}` ).focus();
          document.getElementById(`input_branch_name_${item.id}`).click();
        })
        item.editable = true
        return
      }

      const body = {
        name: value.trim()
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.update(item.id, body)
      if (res.success) {
        this.listDepartment[index].editable = true;
        this.$swal({
          icon: 'success',
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
        });
        this.getListDepartment();
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          showConfirmButton: false,
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()

    },
    async addBranch(item) {
      item.org.isShow = true;
      if(!item.org.children || !item.org.children.length) {
        // const loading = this.$loading.show()
        let res = await organizationMachineRepository.detail(item.id)
        if (res.success) {
          item.org.children = res.data.org.children;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(res, 'message', '')
          });
        }
        // loading.hide()
      }

      this.tempOrgName = '';
      let childTemp = {
        name: 'Default ' + (item.org.children.length + 1),
        parentId: item.org.id,
        level: item.org.level + 1,
        ministryId: item.org.ministryId
      }

      let res = await organizationMachineRepository.createBranch(childTemp)
      if (res.success) {
        this.tempOrgName = 'Default ' + (item.org.children.length + 1);
        let childReturn = _.get(res, 'data', childTemp)
        childReturn.name = '';
        childReturn.showEdit = true
        // childReturn.idTemp = moment().unix()

        item.org.children.push(childReturn)

        this.$nextTick( () => {
          document.getElementById(`input_branch_name_${childReturn.id}` ).focus();
          document.getElementById(`input_branch_name_${childReturn.id}`).click();
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }

    },
    async addPermission() {

    },
    async addRank(item) {
      this.tempRankName = '';
      let childRank = {
        name: 'Default ' + (item.ranks.length + 1),
        orgId: item.id,
        // level: item.level + 1,
        ministryId: item.ministryId
      }
      // return

      let res = await organizationMachineRepository.createRank(childRank)
      if (res.success) {
        this.tempRankName = 'Default ' + (item.ranks.length + 1)
        let childRankReturn = _.get(res, 'data', childRank)
        childRankReturn.name = '';
        childRankReturn.showEdit = true
        childRankReturn.idTemp = moment().unix()


        item.ranks.push(childRankReturn)

        this.$nextTick( () => {
          document.getElementById(`input_rank_name_${childRankReturn.id}` ).focus();
          document.getElementById(`input_rank_name_${childRankReturn.id}`).click();
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }

    },
    editRank(child) {
      child.showEdit = true;
      this.tempRankName = child.name
      this.$nextTick(() => {
        document.getElementById(`input_rank_name_${child.id}`).focus();
        document.getElementById(`input_rank_name_${child.id}`).click();
      });
    },
    async updateRank(rank) {

      if(!rank.name.trim()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Tên lộ trình làm việc không được để trống!'
        });
        rank.name = this.tempRankName ? this.tempRankName : `Default ${rank.id}`
        rank.showEdit = false;
        return
      }


      let dataUpdateBranch = {
        name: rank.name.trim()
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateRank(rank.id, dataUpdateBranch)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        rank.showEdit = false
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
        rank.name = this.tempRankName ? this.tempRankName : `Default ${rank.id}`
        rank.showEdit = false;
      }
      loading.hide()
    },
    async deleteRank(item, rank) {
      if(!rank.users || !rank.users.length) {
        this.$swal({
          title: `Bạn có thực sự muốn xóa rank ${rank.name}`,
          cancelButtonText: 'Bỏ qua',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận'
        }).then( async (res) => {
          if (res.value) {
            const loading = this.$loading.show()
            let res = await organizationMachineRepository.deleteRank(rank.id)
            if (res.success) {
              this.$swal({
                text: 'Cập nhật dữ liệu thành công!',
                timer: 1000,
                showConfirmButton: false,
                icon: 'success'
              });
              let index = item.ranks.findIndex(e => e.id == rank.id);
              if(index > -1) {
                item.ranks.splice(index, 1)
              }
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Lỗi !',
                text: _.get(res, 'message', '')
              });
            }
            loading.hide()
          }
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Bạn không thể xóa Rank đang có nhân sự!'
        });
      }

    },
    async updateBranch(child) {

      if(!child.name.trim()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Tên nhánh không được để trống!'
        });
        child.name = this.tempOrgName ? this.tempOrgName : `Default ${child.id}`
        child.showEdit = false;
        return
      }

      let dataUpdateBranch = {
        name: child.name
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateBranch(child.id, dataUpdateBranch)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        child.showEdit = false
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', ''),
          icon: 'error'
        });
      }
      loading.hide()
    },
    async getDetailBranch(index, item) {

      item.org.isShow = !item.org.isShow;
      if(!item.org.children || !item.org.children.length) {
        const loading = this.$loading.show()
        let res = await organizationMachineRepository.detail(item.id)
        if (res.success) {
          item.org.children = res.data.org.children;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(res, 'message', '')
          });
        }
        loading.hide()
      }
    },
    editBranch(child) {
      this.tempOrgName = child.name;
      child.showEdit = true;
      this.$nextTick(() => {
        document.getElementById(`input_branch_name_${child.id}` ).focus();
        document.getElementById(`input_branch_name_${child.id}`).click();
      })
    },
    async deleteBranch(item) {

      if(!item.org.children || !item.org.children.length) {
        // const loading = this.$loading.show()
        let res = await organizationMachineRepository.detail(item.id)
        if (res.success) {
          item.org.children = res.data.org.children;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(res, 'message', '')
          });
        }
        // loading.hide()
      }

      if(!item.org.children || !item.org.children.length) {
        this.$swal({
          title: `Bạn có thực sự muốn xóa nhánh ${item.org.name}`,
          cancelButtonText: 'Bỏ qua',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận'
        }).then( async (res) => {
          if (res.value) {
            const loading = this.$loading.show()
            let res = await organizationMachineRepository.deleteBranch(item.org.id)
            if (res.success) {
              this.$swal({
                text: 'Cập nhật dữ liệu thành công!',
                timer: 1000,
                showConfirmButton: false,
                icon: 'success'
              });

              item.org = {}
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Lỗi !',
                text: _.get(res, 'message', '')
              });
            }
            loading.hide()
          }
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Bạn không thể xóa Nhánh đang có cấp dưới!'
        });
      }
    },
    async getUserList() {
      const loading = this.$loading.show()
      const params = {
        limit: 1000
      };
      const response = await UserRepository.listUserMinistryAvailable(params);
      loading.hide()
      if (response.success) {
        this.userList = _.get(response, "data", []);
        this.userListCopy = _.get(response, "data", []);
      }
    },
    async saveUserForRank(rank) {
      rank.openMenu = false
      console.log(this.listUserSelected)
      const userIds = {
        userIds: this.listUserSelected && this.listUserSelected.length ? [ ...this.listUserSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateUserForRank(rank.id, userIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });

        const oldUserArrInRank = rank.users.filter(elm => this.listUserSelected.includes(elm .id))

        const newUserArrInRank = this.userList.filter(element => this.listUserSelected.includes(element.id)).map((item) => {
          return {
            avatar: item.avatar ? item.avatar : '',
            fullName: item.fullName,
            id: item.id,
          }
        })
        rank.users = oldUserArrInRank.concat(newUserArrInRank)
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    openFormSelectUser(rank) {
      this.listUserSelected = rank.users.map(elm => elm.id);
      this.getUserList();
    },
    searchUser() {
      if(this.filterForm.name) {
        let keySearch = this.filterForm.name.trim().toUpperCase()
        this.userListCopy = this.userList.filter(element => element.fullName.toUpperCase().includes(keySearch))
      } else {
        this.userListCopy = [ ...this.userList ]
      }
    },

    async getKpiList() {
      const loading = this.$loading.show()
      const params = {
        limit: 1000
      };
      const response = await organizationMachineRepository.listKpi(params);
      loading.hide()
      if (response.success) {
        let listTempKpi = _.get(response, "data", []);
        this.kpiListAll = listTempKpi;
        this.kpiListAllCopy = [ ...listTempKpi ];
      }
    },
    searchKpi() {

    },
    async saveKpiForBranch(item) {

      item.openMenu = false
      const indicatorIds = {
        indicatorIds: this.listKpiSelected && this.listKpiSelected.length ? [ ...this.listKpiSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateKpiForBranch(item.id, indicatorIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        // item.indicators = []
        let indicators = []
        this.kpiListAll.forEach(element => {
          element.indicators.forEach(ite => {
            if(this.listKpiSelected.includes(ite.id)) {
              indicators.push(ite)
            }
          })
        })
        console.log('indicators: ', indicators)
        item.indicators = [ ...indicators ]
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    handleSelectKpi(item) {

      if(this.listKpiSelected.includes(item.id)) {
        let index = this.listKpiSelected.findIndex(ele => ele === item.id)
        if(index > -1) {
          this.listKpiSelected.splice(index, 1);
        }
      } else {
        this.listKpiSelected.push(item.id)
      }

    },
    openFormSelectKpi(item) {
      this.listKpiSelected = item.indicators.map(elm => elm.id)
    },
    openMenuSelectPermission(item) {
      // this.listPermissionSelected = item.roles.map(elm => elm.id)
    },
    async saveRolesForBranch(item) {
      item.openMenuPermission = false
      const roleIds = {
        roleIds: this.listPermissionSelected && this.listPermissionSelected.length ? [ ...this.listPermissionSelected ] : []
      }

      const loading = this.$loading.show()
      let res = await organizationMachineRepository.updateRolesForBranch(item.id, roleIds)
      if (res.success) {
        this.$swal({
          text: 'Cập nhật dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        });
        let roles = []
        this.groupPermissionList.forEach(element => {
          element.roles.forEach(ite => {
            if(this.listPermissionSelected.includes(ite.id)) {
              roles.push({
                id: ite.id,
                name: ite.name
              })
            }
          })
        })
        item.roles = [ ...roles ]
        this.listPermissionSelected = []
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
      loading.hide()
    },
    async getTopicList() {
      const loading = this.$loading.show()
      const params = {
        // limit: 1000
      };
      const response = await RoleRepository.listTopic(params);
      loading.hide()
      if (response.success) {
        this.groupPermissionList = _.get(response, "data", []);
      }
    },
    handleSelectRoles(item) {
      if(this.listPermissionSelected.includes(item.id)) {
        let index = this.listPermissionSelected.findIndex(ele => ele === item.id)
        if(index > -1) {
          this.listPermissionSelected.splice(index, 1);
        }
      } else {
        this.listPermissionSelected.push(item.id)
      }
    },
    deleteDepartment(item) {
      this.$swal({
        title: `Bạn có thực sự muốn xóa bộ phận ${item.name}`,
        cancelButtonText: 'Bỏ qua',
        showCancelButton: true,
        confirmButtonText: 'Xác nhận'
      }).then( async (res) => {
        if (res.value) {
          const loading = this.$loading.show()
          let res = await organizationMachineRepository.delete(item.id)
          loading.hide()
          if (res.success) {
            this.$swal({
              text: 'Cập nhật dữ liệu thành công!',
              timer: 1000,
              showConfirmButton: false,
              icon: 'success'
            });
            this.getListDepartment()
          } else {
            this.$swal({
              icon: 'error',
              type: 'error',
              title: 'Lỗi !',
              text: _.get(res, 'message', '')
            });
          }
        }
      })
    }
  }
};
</script>

<style lang="css" scoped>
  .title-department {
    font-weight: 900;
    font-size: 20px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  /deep/ .btn-add-item {
    width: 20px;
    height: 20px;
    border: 1px dashed;
    border-radius: 50%;
    cursor: pointer;
  }
  .border-gray {
    border: 1px solid gray;
  }
  .text-black {
    color: black;
  }
  .btn-add-department {
    padding: 0px 10px;
    border-radius: 6px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
  }
  .selected {
    background: #1E90FF;
  }
  .v-menu__content.wrapper-v-menu {
    background: white !important;
  }

  .v-menu__content .style-1::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 20px;
    background-color: #F5F5F5;
  }

  .v-menu__content .style-1::-webkit-scrollbar
  {
    width: 3px;
    background-color: #9B51E0;
  }

  .v-menu__content .style-1::-webkit-scrollbar-thumb
  {
    border-radius: 20px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #9B51E0;
  }

  .rank-data-content {
    cursor: pointer;
  }
  .rank-item-actions {
    visibility: hidden;
    font-size: 14px;
    color: #2D9CDB;
    padding: 6px 0px 0px 0px;
  }
  .rank-data-content:hover .rank-item-actions {
    /*display: inline;*/
    visibility: unset;
  }
  .item-user-list-wrapper {
    padding: 0 16px;
  }
  .wrapper-list-item {
    max-height: 150px;
    overflow-y: auto;
  }
  .item-user-content {
    padding: 5px 10px;
    border-bottom: 1px solid #f3efef;
  }
  .btn-confirm {
    border: 1px solid darkgrey;
    border-radius: 5px;
    font-weight: bold;
    text-transform: uppercase;
    color: black;
    cursor: pointer;
  }
  .item-avatar-user {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    transform: translate(0, 2px);
  }
  .more-item-user {
    font-size: 9px;
    background: gainsboro;
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }
  .item-kpi-wrapper {
    padding: 0 16px;
  }
  .item-kpi-content {
    padding: 5px 10px;
    background-color: #EFEEFF;
    color: #7367F0;
    border-radius: 5px;
    display: inline-block;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .btn-confirm {
    border: 1px solid darkgrey;
    border-radius: 5px;
    font-weight: bold;
    text-transform: uppercase;
    color: black;
    cursor: pointer;
  }
  .item-kpi-content-unselect {
    padding: 5px 10px;
    background-color: #F2F2F2;
    color: black;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
  }
  .border-bottom {
    border-bottom: 1px solid #F2F2F2;
  }
  .v-menu__content {
    background: white !important;
  }
  .item-role-content {
    padding: 5px 10px;
    background-color: #EFEEFF;
    color: #7367F0;
    border-radius: 5px;
    /*display: inline-block;*/
    cursor: pointer;
  }
  .item-role-content-unselect {
    padding: 5px 10px;
    background-color: #F2F2F2;
    color: black;
    border-radius: 5px;
    cursor: pointer;
    /*display: inline-block;*/
  }
  .btn-action-item:hover {
    background-color: #dfe8ec;
    border-radius: 5px;
  }
  .btn-action-item {
    width: 33%;
    cursor: pointer;
    text-align: center;
  }
  /deep/ .mdi-plus::before {
    font-weight: bold;
  }
  .tree-header-name {
    cursor: pointer;
    height: fit-content;
  }
  .btn-edit-kpi {
    text-decoration: underline;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
    display: inline-block;
  }
  .icon-header-tree-note {
    margin-right: 2px;
    position: absolute;
    top: 6px;
    right: 0px;
    cursor: pointer;
  }
  .btn-action-branch, .btn-action-department {
    /*display: none;*/
    visibility: hidden;
    font-size: 14px;
    color: #2D9CDB;
    padding: 6px 0px 0px 0px;
  }
  .tree-header-name:hover .btn-action-branch, .title-department-content:hover .btn-action-department {
    visibility: unset;
    cursor: pointer;
  }
  .btn-action-department {
    margin-left: 20px;
    text-transform: capitalize !important;
    font-weight: 400;
  }
  input:focus {
    outline: none;
    border-radius: 5px;
  }
</style>
